import { useTranslation } from 'translations/hooks';

import { NumberRangeValue } from 'ui/form/number-range-input';
import { PreselectRingRangeTypeEnum } from 'ui/form/preselect-ring-range-input';

export const useRangeSize = (
  setCurrentType: (type: PreselectRingRangeTypeEnum) => void,
  handleRingChange: (range: NumberRangeValue) => void,
  lastRing?: number | null,
) => {
  const { t } = useTranslation();
  return {
    handleSelectChange: (type: PreselectRingRangeTypeEnum) => {
      setCurrentType(type);

      // lastRing - (x - 1) because the query checks for ringNumber >= startRing
      // which is equivalent to ringNumber > startRing - 1
      switch (type) {
        case PreselectRingRangeTypeEnum.All:
          handleRingChange([null, null]);
          break;
        case PreselectRingRangeTypeEnum.LastTen:
          handleRingChange([lastRing ? lastRing - (10 - 1) : null, lastRing]);
          break;
        case PreselectRingRangeTypeEnum.LastFifty:
          handleRingChange([lastRing ? lastRing - (50 - 1) : null, lastRing]);
          break;
        case PreselectRingRangeTypeEnum.LastOneHundred:
          handleRingChange([lastRing ? lastRing - (100 - 1) : null, lastRing]);
          break;
        case PreselectRingRangeTypeEnum.LastTwoHundred:
          handleRingChange([lastRing ? lastRing - (200 - 1) : null, lastRing]);
          break;
        default:
          throw new Error('Unreachable');
      }
    },
    options: [
      {
        label: t('ring.preselectRingRangeSelect.all'),
        value: PreselectRingRangeTypeEnum.All,
      },
      {
        label: t('ring.preselectRingRangeSelect.lastTen'),
        value: PreselectRingRangeTypeEnum.LastTen,
      },
      {
        label: t('ring.preselectRingRangeSelect.lastFifty'),
        value: PreselectRingRangeTypeEnum.LastFifty,
      },
      {
        label: t('ring.preselectRingRangeSelect.lastOneHundred'),
        value: PreselectRingRangeTypeEnum.LastOneHundred,
      },
      {
        label: t('ring.preselectRingRangeSelect.lastTwoHundred'),
        value: PreselectRingRangeTypeEnum.LastTwoHundred,
      },
    ],
  };
};
